import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddLanguages, Languages } from '../models/languages/languages';


@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getLanguages(LanguagesId?: number): Observable<Languages[]>{
        return this._http.get<Languages[]>(`${environment.api.url}/Languages?LanguagesId=${LanguagesId??''}`);
    }
  
    public deleteLanguages(LanguagesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Languages/${LanguagesId}`);
    }
  
    public addLanguages(model: AddLanguages): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Languages`, model);
    }
}
